import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConstantsService } from '../services/constants.service';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {
  @Input() messageType: string;  //message type - error or success
  @Input() message: string;  //message type - error or success
  @Output() closeClick: EventEmitter<string> = new EventEmitter(); 
  
  constructor(
    public constants: ConstantsService
  ) { }

  ngOnInit(): void {
  }
 
  closeAlert() {
     this.closeClick.emit();
  }

}
